module.exports = __webpack_public_path__ + "static/media/additional.b26cb803.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/additional.svg
// module id = 16
// module chunks = 0